import { currentAuthSession } from "./Login/State";

import { store } from "./Store";

export const getAuthSession = () => {
  const state = store.getState();
  return currentAuthSession(state);
};
